import React from "react";
import Header from "@/components/Header";
import TopBanners from "@/components/TopBanners";
import ActivityTicker from "@/components/ActivityTicker";
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <TopBanners />
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {children}
      </main>
      <ActivityTicker />
      <footer className="border-t border-border bg-card/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-muted-foreground">
          <div className="urdu-naskh">© PakNet — پاکستان کا اردو فورم</div>
          <div className="font-eng text-xs opacity-70">Built with FastAPI · React · MongoDB</div>
        </div>
      </footer>
      <Toaster richColors position="top-center" dir="rtl" />
    </div>
  );
}
